import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import classnames from 'classnames';
import DonutChartArc from './components/donut-chart-arc/DonutChartArc';

import styles from './DonutChart.module.scss';

interface DonutSegment {
  key: string;
  percentage?: number;
  color?: string;
  tooltip?: string;
  className?: string;
}
interface DonutChartProps {
  segments: Array<DonutSegment>;
  className?: string;
  centralText?: string;
}
function DonutChart({
  className,
  segments,
  centralText,
}: DonutChartProps): JSX.Element {
  const [displayedSegments, setDisplayedSegments] = useState<
  Array<DonutSegment & { offset: number; }>
  >([]);
  useEffect(() => {
    let offset = 0;
    setDisplayedSegments(
      [...segments]
        .reverse()
        .filter((segment) => segment.percentage)
        .map((segment) => {
          offset += segment.percentage || 0;
          return ({
            key: segment.key,
            percentage: segment.percentage,
            color: segment.color,
            tooltip: segment.tooltip,
            offset: offset - (segment.percentage || 0),
            className: segment.className,
          });
        }),
    );
  }, [segments]);
  const svgRef = useRef<SVGSVGElement>(null);
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 42 42"
      className={className}
      style={{ overflow: 'visible' }}
      ref={svgRef}
    >
      <circle
        className={styles.ring}
        cx="21"
        cy="21"
        r="15.91549430918954"
      />

      {centralText && (
        <text
          x={21}
          y={21}
          dominantBaseline="central"
          textAnchor="middle"
          className={styles.centralText}
        >
          {centralText}
        </text>
      )}

      { displayedSegments.map((segment) => (
        <DonutChartArc
          key={segment.key}
          centerX={21}
          centerY={21}
          angle={15.91549430918954}
          segment={segment}
          className={classnames(styles.segment, segment.className)}
          parentRef={svgRef.current}
        />
      ))}
      { displayedSegments.map((segment) => (
        <use
          id="#tooltipwrapper"
          xlinkHref={`#${segment.key}`}
          key={`${segment.key}_tooltip_wrapper`}
        />
      ))}
    </svg>
  );
}

export default DonutChart;
